import cookies from 'js-cookie';

import buildComponent from './utils/build-component';

export default (nameSpace) => buildComponent({
  nameSpace,
  initFunction: ($el, params) => {
    const $closeEl = $el.querySelector(`.${nameSpace}__close`);

    //
    // Methods
    //

    //
    // Life Cycle
    //

    //
    // Procedures
    //

    if (typeof cookies.get(nameSpace) === 'undefined') {
      $el.classList.add(`${nameSpace}--is-shown`);
      $closeEl.addEventListener('click', () => {
        cookies.set(nameSpace, true, { expires: 30 });
        $el.classList.remove(`${nameSpace}--is-shown`);
      });
    }
  
    //
    // Listeners / Observers
    //

    //
    // Public API
    //

    return {
    };
  }
});



// WEBPACK FOOTER //
// ./src/scripts/cookie-banner.js